export default function getNotificationTypesFromSelectedTab(selectedTab) {
  return (
    selectedTab?.notificationTypes?.map(
      ({ notificationType }) => notificationType
    ) ?? []
  );
}
